<template>
    <UtilitiesWebView url="/about/land-acknowledgment" />
</template>
